import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Axios from 'axios';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "react-auth-kit";
import $ from 'jquery';

Sentry.init({
  dsn: process.env.NODE_ENV === 'production'
    ? "https://075915beb7cf6c1d235b8dcd47e58482@o4510863423897600.ingest.us.sentry.io/4510863749742592"
    : undefined,
  sendDefaultPii: true,
});

// Skip ngrok interstitial page for all requests
// Axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';
// Load wiris formula render script.
const jsDemoImagesTransform = document.createElement('script');
jsDemoImagesTransform.type = 'text/javascript';
jsDemoImagesTransform.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
document.head.appendChild(jsDemoImagesTransform);
// This needs to be included before the '@wiris/mathtype-tinymce6' is loaded synchronously
window.$ = $;
window.tinymce = require('tinymce');  // Expose the TinyMCE to the window.
// Load wiris plugin synchronously.
require('@wiris/mathtype-tinymce6');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//   <React.StrictMode>
    <>
        <AuthProvider
            authType={"cookie"}
            authName={"_auth"}
            cookieDomain={window.location.hostname}
            cookieSecure={false} // true when using https
        >
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </AuthProvider>
    </>
//   </React.StrictMode>
);